import React from 'react';
import SecondaryHeading from "../SecondaryHeading/SecondaryHeading";
import ThirdHeading from "../ThirdHeading/ThirdHeading";
import ColumnsBarChart from "../ColumnsBarChart/ColumnsBarChart";
import './ComplexChart.styles.scss';

function ComplexChart({ title, subTitle, note, ...data }) {
    return (
        <div className="complex-chart">
            <div className="complex-chart__top">
                <div className="complex-chart__left">
                    <SecondaryHeading>
                        {title}
                    </SecondaryHeading>
                    <ThirdHeading>
                        {subTitle}
                    </ThirdHeading>
                </div>
                <div className="complex-chart__right">
                    <ThirdHeading>
                        {note}
                    </ThirdHeading>
                </div>
            </div>
            <ColumnsBarChart {...data}/>
        </div>
    );
}

export default ComplexChart;